export default __webpack_public_path__ + "static/media/bin-trash.da501ad6.svg";